module.exports = __webpack_public_path__ + "media/public/img/locations/san-francisco-291e2f0dd89768034af533f33f00af73.svg";